import styled from "styled-components";

export const Item = styled.li`
  max-width: 300px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 20px;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`;

export const Location = styled.div`
  &:nth-child(1) {
    color: ${({ theme }) => theme.colors.accent2};
  }

  &:nth-child(2) {
    text-align: right;
  }
`;

export const Time = styled.p`
  font-size: 24px;
  text-align: center;
  margin-top: 8px;
`;

export const Body = styled.div`
  display: flex;
  margin-top: 12px;
  margin-bottom: 20px;
`;

export const Wrap = styled.div`
  width: 100%;
  text-align: right;
  padding-right: 12px;
  border-right: 2px solid ${({ theme }) => theme.colors.text};

  &:nth-child(2) {
    text-align: left;
    padding-left: 12px;
    border-right: none;
    padding-right: 0;
  }
`;

export const Temp = styled.p`
  font-size: 32px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 24px;
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.colors.accent2};
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
`;

export const Details = styled.a`
  display: block;
  background-color: ${({ theme }) => theme.colors.accent1};
  border-radius: 12px;
  color: ${({ theme }) => theme.colors.text};
  padding: 8px 16px;
  font-size: 16px;
  font-family: "Montserrat";
  font-weight: 500;
  width: max-content;
  width: 100%;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.colors.background};
    background-color: ${({ theme }) => theme.colors.accent2};
  }
`;

export const Pros = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
`;

export const Pro = styled.button`
  background-color: ${({ theme }) => theme.colors.background};
  line-height: 0;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  border: 3px solid ${({ theme }) => theme.colors.accent1};

  &:hover {
    border: 3px solid ${({ theme }) => theme.colors.accent2};
  }
`;
